'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const EventTimelinePremiumStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventTimelinePremiumStyledContext.displayName = "EventTimelinePremiumStyledContext";
export function useEventTimelinePremiumStyledContext() {
  const value = React.useContext(EventTimelinePremiumStyledContext);
  if (!value) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: EventTimelinePremiumStyledContext is missing. ' + '`useEventTimelinePremiumStyledContext` cannot read the timeline styled context (classes, localeText, resourceColumnLabel) without a provider. ' + 'Make sure the calling component is rendered inside <EventTimelinePremium />.' : _formatErrorMessage(271));
  }
  return value;
}